import _ from "lodash";
import React from "react";

import VideoLayout from "../../../../../modules/UI/videolayout/VideoLayout";
import { getConferenceNameForTitle } from "../../../base/conference";
import { connect, disconnect } from "../../../base/connection";
import { translate } from "../../../base/i18n";
import { connect as reactReduxConnect } from "../../../base/redux";
import { Filmstrip } from "../../../filmstrip";
import { setToolboxVisible } from "../../../toolbox/actions.any";
import { SETTINGS_TABS } from "../../../settings/constants";
import { sendAnalytics, createToolbarEvent } from "../../../analytics";
import FireChat from "./FireChat";
import Toolbox from "./Toolbox";
import InviteMore from "./InviteMore";
import {
    getCurrentLayout,
    LAYOUTS,
    shouldDisplayTileView,
} from "../../../video-layout";
import { maybeShowSuboptimalExperienceNotification } from "./../../../conference/functions";
import Chat from "../../services/Chat";

// SECURED
import { openSettingsDialog } from "../../actions";
import { LargeVideo } from "../../../large-video";
import {
    validateMeeting,
    DefaultLobby,
    getMediaDownloadUrl,
} from "../Meet/meet_actions";
import { Authorized_User } from "../Call/call_actions";
import MeetPassword from "./MeetPassword";
import MeetInterface from "./MeetInterface";
import AuthService from "../../services/authService";
import swal from "sweetalert";
import { SendCommandOnce } from "./actions";
import LoaderPage from "./LoaderPage";
import { firebaseDatabase } from "../../services/firebaseService";
import KnockingParticipantList from "../Widgets/KnockingParticipantList";
import RaiseHandScreen from "../Widgets/RaiseHandScreen";
import { PARTICIPANT_IS_HOST } from "../../actionTypes";
import { getLocalVideoTrack } from "../../../base/tracks";
import { _getAllParticipants } from "./actions";
import { updateSettings } from "../../../base/settings";
import authService from "../../services/authService";
import { SignoutUser } from "../../firebase/firebaseActions";
import ErrorBoundary from "../ErrorBoundary";

declare var APP: Object;
declare var interfaceConfig: Object;

const LAYOUT_CLASSNAMES = {
    [LAYOUTS.HORIZONTAL_FILMSTRIP_VIEW]: "horizontal-filmstrip",
    [LAYOUTS.TILE_VIEW]: "tile-view",
    [LAYOUTS.VERTICAL_FILMSTRIP_VIEW]: "vertical-filmstrip",
};
type Props = AbstractProps & {
    _iAmRecorder: boolean,
    _layoutClassName: string,
    _roomName: string,
    dispatch: Function,
    t: Function,
};

class JitsiMeet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isConnected: false,
            hasPassword: false,
            isAuthenticatedRoom: true,
            videoCall: false,
            toolBoxShow: false,
            JoineeList: false,
            is_owner: false,
            restricted: false,
            host: "",
            topic: "",
            roomID: "",
            hostID: 0,
            phone: "",
            viewLayout: "grid",
            isMaximize: false,
            disconnecting: false,
            __waitingScreen: false,
            __notificationSent: false,
            __isScheduled: false,
            __meetingEnds: 0,
            __sharingOn: true,
            __onlyAuthJoin: false,
            __enableWaitingScreen: true,
            __isInitVideoMuted: false,
            __isInitAudioMuted: false,
            fireGroupParticipants: {},
        };
        this.timeout = 0;
        this.meetDuration = 0;
    }

    componentDidMount = async () => {
        const { iAmRecorder } = this.props;
        if (iAmRecorder) {
            APP.store.dispatch(
                updateSettings({
                    displayName: `Recorder`,
                })
            );
            this._start();
        } else {
            sessionStorage.removeItem("userRole");
            sessionStorage.removeItem("host_name");
            const { _roomName, uniquekey } = this.props;
            document.title = `${_roomName} | ${interfaceConfig.APP_NAME}`;
            let customerID = AuthService.getUserDetail()?.customerID;
            let apiResponse = await APP.store.dispatch(
                validateMeeting({
                    room_name: _roomName.replace(/\s+/g, "").toLowerCase(),
                    uniquekey,
                })
            );
            if (apiResponse.code === 1) {
                const {
                    host_name: host,
                    room_name: roomID,
                    is_owner: hostID,
                    topic,
                    phone,
                    meet_type,
                    locked,
                    timestamp,
                    password_protected,
                    meeting_time,
                    media,
                } = apiResponse;
                let ifOwner = parseInt(customerID) === parseInt(hostID);
                this.setState(
                    {
                        host,
                        roomID,
                        hostID,
                        topic,
                        phone,
                        __isScheduled: meet_type !== "instant",
                        restricted:
                            locked === "Y" &&
                            parseInt(customerID) !== parseInt(hostID),
                        is_owner: parseInt(customerID) === parseInt(hostID),
                        __meetingEnds: meeting_time,
                        __isInitVideoMuted: ifOwner
                            ? false
                            : media && JSON.parse(media).video_muted,
                        __isInitAudioMuted: ifOwner
                            ? false
                            : media && JSON.parse(media).audio_muted,
                    },
                    () => {
                        let { restricted, __isScheduled, is_owner } =
                            this.state;
                        if (__isScheduled) {
                            const {
                                auth_share,
                                join_authorized,
                                enableLobby,
                                join_after_host,
                            } = apiResponse;
                            this.setState(
                                {
                                    __sharingOn: auth_share === "Y",
                                    __onlyAuthJoin: join_authorized === "Y",
                                    __enableWaitingScreen:
                                        join_after_host === "Y",
                                },
                                () => {
                                    if (
                                        join_authorized === "Y" &&
                                        parseInt(customerID) > 0 === false
                                    ) {
                                        restricted = true;
                                        Authorized_User(false);
                                        return false;
                                    }
                                    if (enableLobby === "Y") {
                                        DefaultLobby(true);
                                        this.CallAfterExecutionnitially({
                                            restricted,
                                            timestamp,
                                            password_protected,
                                            is_owner,
                                            meeting_time,
                                        });
                                        this.UpdateFirebaseParticipants();
                                    }
                                }
                            );
                        } else {
                            this.CallAfterExecutionnitially({
                                restricted,
                                timestamp,
                                password_protected,
                                is_owner,
                                meeting_time,
                            });
                            this.UpdateFirebaseParticipants();
                        }
                        sessionStorage.setItem("host_name", host);
                    }
                );
            } else {
                let { phone } = AuthService.getUserDetail();
                phone = phone && phone.toString().replace("+", "");
                let RoomSplitter = _roomName.split(" ");
                if (RoomSplitter && RoomSplitter.includes(phone)) {
                    this.setState({ videoCall: true }, () => {
                        this.setState({ isConnected: true }, () => {
                            this._start();
                        });
                    });
                    this.__UserEntryPoint(); // FIREBASE FUNCTIONALITY
                    sessionStorage.setItem("userRole", "owner");
                    sessionStorage.setItem("host_name", "user");
                } else {
                    swal({
                        title: "Not Found!",
                        text: "Video Call you request for is not found!",
                        icon: "error",
                        buttons: true,
                    }).then(() => {
                        window.close();
                    });
                }
            }
        }
    };

    componentDidUpdate(prevProps) {
        const { __notificationSent, is_owner } = this.state;
        const {
            _meetDetail: { uniquekey = "" },
            isSharingScreen,
            _participants,
        } = this.props;

        let conference =
            APP.store.getState()?.["features/base/conference"]?.conference;
        const {
            isSharingScreen: oldIsSharingScreen,
            _participants: oldParticipants,
        } = prevProps;

        if (oldIsSharingScreen !== isSharingScreen && isSharingScreen) {
            const { sendCommandOnce } = APP.conference.commands;
            sendCommandOnce("full-view-screen-share", {
                value: APP.conference.getMyUserId(),
            });
        }
        if (conference && !__notificationSent) {
            this.setState({ __notificationSent: true }, () => {
                if (
                    _participants?.length === 1 &&
                    !conference?.properties?.uniquekey
                ) {
                    conference?._updateProperties({ uniquekey });
                } else if (
                    is_owner &&
                    uniquekey !== conference?.properties?.uniquekey
                ) {
                    conference?._updateProperties({ uniquekey });
                    SendCommandOnce("refresh-to-all", uniquekey);
                }
            });
        }
        if (
            this.props._shouldDisplayTileView ===
            prevProps._shouldDisplayTileView
        ) {
            return;
        }
        VideoLayout.refreshLayout();
    }

    componentWillUnmount() {
        APP.UI.unbindEvents();
        APP.conference.isJoined() && this.props.dispatch(disconnect());
        clearTimeout(this.timeout);
        clearInterval(this.meetDuration);
    }

    render() {
        const {
            isConnected,
            isAuthenticatedRoom,
            hasPassword,
            disconnecting,
            toolBoxShow,
            JoineeList,
            is_owner,
            restricted,
            viewLayout,
            isMaximize,
            __waitingScreen,
            __sharingOn,
            __isInitVideoMuted,
            __isInitAudioMuted,
            __notificationSent,
            fireGroupParticipants,
        } = this.state;


        console.log("jitsi meet",this.state)

        const { filmStripOnly: filmstripOnly } = interfaceConfig;
        const {
            _roomName,
            _layoutClassName,
            _chatOpen,
            _screenShares,
            _participants,
            _tracks,
            _tileViewEnabled,
            nxatel_call: { newMessageCount, authorized_user },
            uniquekey,
            _meetDetail: { topic },
            _screensharing,
            meetingDetails,
            iAmRecorder,
            __GuestAlreadyExists, 
        } = this.props;  

        const RenderFxn = () => {
            if (
                !is_owner &&
                (restricted || !authorized_user) &&
                !iAmRecorder &&
                !__GuestAlreadyExists
            ) {
                return (
                    <LoaderPage type={restricted ? "locked" : "unauthorized"} />
                );
            } else if (
                !isConnected &&
                __waitingScreen &&
                !iAmRecorder &&
                !__GuestAlreadyExists
            ) {
                return <LoaderPage type="waiting" />;
            } else if (
                !isAuthenticatedRoom &&
                !iAmRecorder &&
                !__GuestAlreadyExists
            ) {
                return <LoaderPage type="not-found" />;
            } else if (
                !isConnected &&
                hasPassword &&
                !__waitingScreen &&
                !iAmRecorder &&
                !__GuestAlreadyExists
                // && AuthService.isAuthenticated()   now guest user can also join schedule meeting if host added.
            ) {
                // IF USER IS LOGGEDIN
                return (
                    <MeetPassword
                        {...{
                            _openDeviceSettings: this._openDeviceSettings,
                            uniquekey,
                            _roomName,
                        }}
                    />
                );
            } else if (!isConnected && !iAmRecorder && !__GuestAlreadyExists) {
                return (
                    <LoaderPage type={disconnecting ? "disconnecting" : ""} />
                );
            } else {
                return (
                    <>
                        {isConnected &&
                            APP.conference.roomName &&
                            !iAmRecorder && (
                                <InviteMore
                                    {...{
                                        is_owner,
                                        restricted,
                                        uniquekey,
                                        onUpdateRestriction:
                                            this.__onUpdateRestriction,
                                        meetingDetails,
                                        fireGroupParticipants,
                                    }}
                                />
                            )}

                        {isConnected && is_owner && !iAmRecorder && (
                            <KnockingParticipantList is_owner={is_owner} />
                        )}
                        {isConnected && is_owner && !iAmRecorder && (
                            <RaiseHandScreen />
                        )}

                        {(isConnected || iAmRecorder) && (
                            <div
                                className={`loader1 d-flex assembed-video-meet ${
                                    _chatOpen ? "active-side-chat" : ""
                                }`}
                            >
                                <div
                                    className={`middle-part-video-meet w-100 d-flex flex-column justify-content-between`}
                                >
                                    <MeetInterface
                                        {...{
                                            topic,
                                            is_owner,
                                            _participants,
                                            _screensharing,
                                            viewLayout,
                                            _tracks,
                                            _chatOpen,
                                            _tileViewEnabled,
                                            _screenShares,
                                            meetingDetails,
                                            isMaximize,
                                            setMaximize: (isMaximize) => {
                                                this.setState({ isMaximize });
                                            },
                                            setView: (viewLayout) => {
                                                this.setState({ viewLayout });
                                            },
                                            fireGroupParticipants,
                                        }}
                                    />
                                </div>
                                {APP.conference.roomName &&
                                    APP.conference.getMyUserId() && (
                                        <FireChat
                                            {...{
                                                _chatOpen,
                                                is_owner,
                                                uniquekey,
                                            }}
                                        />
                                    )}
                                <div
                                    id="videospace"
                                    style={{ display: "none" }}
                                >
                                    <LargeVideo />
                                    <Filmstrip filmstripOnly={filmstripOnly} />
                                </div>
                            </div>
                        )}

                        <div
                            className={`bottom-part-video-meet ${
                                isConnected && toolBoxShow ? "" : "hide"
                            } ${_chatOpen ? "bottom-part-with-chat" : ""}`}
                        >
                            {isConnected && !iAmRecorder && (
                                <Toolbox
                                    {...{
                                        JoineeList,
                                        _screenShares,
                                        _participants,
                                        newMessageCount,
                                        is_owner,
                                        __sharingOn,
                                        meetingDetails,
                                        __isInitVideoMuted,
                                        __isInitAudioMuted,
                                        __notificationSent,
                                        uniquekey,
                                        ToggleJoinee: () => {
                                            this.setState({
                                                JoineeList: !JoineeList,
                                            });
                                        },
                                        Disconnect: this.__Disconnect,
                                    }}
                                />
                            )}
                        </div>
                    </>
                );
            }
        };
        return (
            <ErrorBoundary>
                <div
                    className={`${_layoutClassName} ${
                        isMaximize ? "full-share-screen-view" : ""
                    }`}
                    id="videoconference_page"
                    onMouseMove={this.__MouseMoveHandler}
                >
                    <button
                        type="button"
                        style={{ display: "none" }}
                        id="joinModal"
                        onClick={() =>
                            this.setState({ isConnected: true }, () => {
                                this._start();
                            })
                        }
                    />
                    {RenderFxn()}
                </div>
            </ErrorBoundary>
        );
    }

    __MouseMoveHandler = () => {
        this.setState({ toolBoxShow: true });
        if (this.timeout > 0) {
            clearTimeout(this.timeout);
            this.timeout = 0;
        }
        this.timeout = setTimeout(() => {
            this.setState({ toolBoxShow: false });
        }, 5000);
    };

    __Disconnect = () => {
        this.setState(
            {
                isConnected: false,
                disconnecting: true,
            },
            () => {
                authService.logout();
                SignoutUser();
                window.location.href = `https://${process.env.REACT_APP_WEBSITE_DOMAIN}`;
            }
        );
    };

    __UserEntryPoint = () => {
        const { roomID, host, topic, phone: fromNumber, hostID } = this.state;
        if (
            AuthService.isAuthenticated() &&
            AuthService.getUserDetail()?.phone &&
            hostID !== AuthService.getUserDetail()?.customerID
        ) {
            let toNumber = AuthService.getUserDetail().phone.replace("+", "");
            let MemberRef = firebaseDatabase.ref("InviteMembers");
            MemberRef.once("value", (snapshot) => {
                if (!snapshot.hasChild(toNumber)) {
                    MemberRef.child(toNumber).set({
                        toNumber: toNumber,
                        fromNumber: fromNumber.replace("+", ""),
                        roomID,
                        host,
                        status: "Connected",
                        topic,
                    });
                } else {
                    MemberRef.child(toNumber)
                        .get()
                        .then((snapshot) => {
                            let checkStatus = snapshot.val();
                            if (checkStatus["status"] === "Connecting") {
                                MemberRef.child(toNumber).set({
                                    ...checkStatus,
                                    status: "Connected",
                                });
                            }
                        });
                }
            });
            MemberRef.child(toNumber)
                .onDisconnect()
                .remove((err) => {
                    if (err !== null) {
                        console.error(err);
                        return false;
                    }
                });
        }
    };

    __IfHostExists = () => {
        const { __enableWaitingScreen } = this.state;
        let { uniquekey } = this.props;
        firebaseDatabase.ref("Groups").on("value", (snapshot) => {
            if (snapshot.hasChild(uniquekey)) {
                let group_obj = snapshot.child(uniquekey).val();
                let { participants } = group_obj;
                if (participants instanceof Array) {
                    let getData = participants.filter(
                        (value) => value.owner && value.online
                    );
                    if (getData.length) {
                        this.setState({ __waitingScreen: false }, () => {
                            this._openDeviceSettings(true);
                        });
                        firebaseDatabase.ref("Groups").off();
                    } else if (__enableWaitingScreen) {
                        this.setState({ __waitingScreen: true });
                    }
                } else if (__enableWaitingScreen) {
                    this.setState({ __waitingScreen: true });
                }
            } else if (__enableWaitingScreen) {
                this.setState({ __waitingScreen: true });
            }
        });
    };

    CallAfterExecutionnitially = ({
        restricted,
        password_protected,
        is_owner,
    }) => {
        if (!restricted) {
            // FIREBASE FUNCTIONALITY
            this.__UserEntryPoint();
            // PASSWORD FUNCTIONALITY
            if (is_owner) {
                sessionStorage.setItem("userRole", "owner");
                this._openDeviceSettings(true);
                APP.store.dispatch({
                    type: PARTICIPANT_IS_HOST,
                    payload: true,
                });
            } else {
                if (password_protected) {
                    this.setState({ hasPassword: true });
                } else {
                    this.__IfHostExists();
                }
                sessionStorage.setItem("userRole", "member");
            }
        }
    };

    __onUpdateRestriction = () => {
        this.setState((prevState) => ({ restricted: !prevState.restricted }));
    };

    _start = async () => {
        APP.UI.start();
        APP.UI.registerListeners();
        APP.UI.bindEvents();

        const { dispatch, t } = this.props;

        dispatch(connect());

        maybeShowSuboptimalExperienceNotification(dispatch, t);

        interfaceConfig.filmStripOnly && dispatch(setToolboxVisible(true));
        if (localStorage.video_muted === "true") {
            APP.conference.muteVideo(true);
        }
        if (localStorage.audio_muted === "true") {
            let muteTimeout = setTimeout(() => {
                APP.conference.muteAudio(true);
                clearTimeout(muteTimeout);
            }, 1500);
        }

        const { app_picture = "" } = AuthService.getUserDetail() || {};
        if (app_picture) {
            let imageUrl = await getMediaDownloadUrl(app_picture);
            if (imageUrl) {
                APP.store.dispatch(
                    updateSettings({
                        avatarURL: imageUrl,
                    })
                );
            }
        }
    };

    _openDeviceSettings = async (host = true) => {
        if (host) {
            const { defaultTab = SETTINGS_TABS.DEVICES, dispatch } = this.props;
            sendAnalytics(createToolbarEvent("settings"));
            await dispatch(openSettingsDialog(defaultTab));
            const {
                firstname = "",
                lastname = "",
                app_picture = "",
            } = AuthService.getUserDetail() || {};
            let displayName = `${firstname}${lastname ? ` ${lastname}` : ""}`;
            APP.store.dispatch(
                updateSettings({
                    displayName,
                    email: AuthService.getUserDetail()?.email,
                })
            );
            if (app_picture) {
                let imageUrl = await getMediaDownloadUrl(app_picture);
                if (imageUrl) {
                    APP.store.dispatch(
                        updateSettings({
                            avatarURL: imageUrl,
                        })
                    );
                }
            }
            this.setState({ hasPassword: false });
        } else {
            this.__IfHostExists();
        }
    };

    UpdateFirebaseParticipants = () => {
        let { uniquekey } = this.props;
        const __UpdateUsers = (users) => {
            if (users?.participants) {
                const { participants } = users;
                let fireGroupParticipants = {};
                {
                    participants instanceof Array &&
                        participants.map((value) => {
                            let { online, owner, type, id } = value;
                            fireGroupParticipants = {
                                ...fireGroupParticipants,
                                [id]: { online, owner, type },
                            };
                        });
                }
                this.setState({ fireGroupParticipants });
            }
        };
        Chat.fetch_ref_on_update(`Groups/${uniquekey}`, __UpdateUsers);
    };
}
function _mapStateToProps(state, ownProps) {
    const tracks = state["features/base/tracks"];
    const screenShares = state["features/video-layout"].screenShares || [];
    const { documentUrl } = state["features/etherpad"];
    const { visible = Boolean(documentUrl) } = ownProps;
    const localVideo = getLocalVideoTrack(state["features/base/tracks"]);
    let isSharingScreen = APP.conference.isSharingScreen;
    let _participants = _getAllParticipants();
    _participants =
        _participants &&
        _participants?.filter((value) => value.name !== "Recorder");
    return {
        nxatel_call: state["features/nxatel_call"],
        _roomName: getConferenceNameForTitle(state),
        _layoutClassName: LAYOUT_CLASSNAMES[getCurrentLayout(state)],
        _chatOpen: state["features/chat"].isOpen, // to check if chat is enabled
        _participants,
        _tracks: tracks,
        _screenShares: screenShares.length,
        _meetDetail: state["features/nxatel_meet"].meeting_details,
        extension_list: state["features/nxatel_meet"].extension_list,
        default_lobby: state["features/nxatel_meet"].default_lobby,
        _tileViewEnabled: shouldDisplayTileView(state),
        _screensharing: localVideo && localVideo.videoType === "desktop",
        visible,
        isSharingScreen,
    };
}

export default reactReduxConnect(_mapStateToProps)(translate(JitsiMeet));
